// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/widgets/UploadTray/styles.scss
// module id = 831
// module chunks = 0